export default __webpack_public_path__ + "static/media/valid.3853760d.svg";